<template>
  <v-tabs
    class="answer-container mt-2"
    v-if="this.JourneyTypes[0].id !== null"
    background-color="grey lighten-3"
    v-model="journeyTabs"
  >
    <v-tabs-slider color="accent"></v-tabs-slider>
    <v-tab
      v-for="journey in journeys"
      :key="journey.id"
      :class="{ 'font-weight-bold': SelectedCustomer.active_journey.id === journey.id }"
      >{{ journey.name }}</v-tab
    >

    <v-tab-item v-for="journey in journeys" :key="journey.id">
      <v-layout wrap mt-2>
        <v-flex xs12>
          <v-card
            class="ml-0"
            :class="{ 'mr-2': $vuetify.breakpoint.width <= 1600, 'mr-1': $vuetify.breakpoint.width > 1600 }"
          >
            <enquiry-list :enquiries="journeyEnquiries(journey.id)" :funderView="false"></enquiry-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import EnquiryList from './EnquiryList';

export default {
  name: 'enquiries-container',
  components: { EnquiryList },
  props: ['enquiries'],
  data: () => ({
    journeyTabs: 0
  }),
  computed: {
    ...mapGetters(['JourneyTypes', 'SelectedCustomer', 'UserHasRole']),
    journeys: function() {
      if (_.isNull(this.JourneyTypes[0].id)) {
        return [{ name: 'loading...', id: '123' }];
      }
      const current = _.filter(
        this.JourneyTypes[1].journeys,
        journey => journey.id === this.SelectedCustomer.active_journey.id
      );
      let others = _.orderBy(
        _.filter(this.JourneyTypes[1].journeys, journey => journey.id !== this.SelectedCustomer.active_journey.id),
        'name'
      );
      if (this.UserHasRole('Property Broker')) {
        others = _.filter(others, journey => journey.name !== 'Business Funding');
      }
      return _.uniqBy([...current, ...others], 'id');
    }
  },
  methods: {
    journeyEnquiries: function(journeyId) {
      return _.filter(this.enquiries, enquiry => enquiry.journey.id === journeyId);
    }
  }
};
</script>

<style lang="scss" scoped>
.answer-container {
  height: calc(100vh - 200px);
  max-height: calc(100vh - 200px);
  overflow: hidden;
}
</style>
